import { useEffect, useId } from 'react';
import type { ReactNode } from 'react';

interface JanelaModalProps {
    titulo: string;
    aoFechar: () => void;
    /** Durante o processamento nada fecha: a resposta do servidor ainda vai chegar. */
    bloqueada?: boolean;
    children: ReactNode;
}

/** O popup do modelo (`img_3.png`): título, X no canto e Esc fechando como o Cancelar. */
export function JanelaModal({ titulo, aoFechar, bloqueada = false, children }: JanelaModalProps) {
    const idDoTitulo = useId();

    useEffect(() => {
        function aoTeclar(evento: KeyboardEvent) {
            if (evento.key === 'Escape' && !bloqueada) aoFechar();
        }
        document.addEventListener('keydown', aoTeclar);
        return () => document.removeEventListener('keydown', aoTeclar);
    }, [bloqueada, aoFechar]);

    return (
        <div className="fundo-confirmacao">
            <div className="confirmacao" role="dialog" aria-modal="true" aria-labelledby={idDoTitulo}>
                <button type="button" className="fechar-confirmacao" aria-label="Fechar" onClick={aoFechar} disabled={bloqueada}>
                    ×
                </button>
                <h3 id={idDoTitulo}>{titulo}</h3>
                {children}
            </div>
        </div>
    );
}

/** O código de acesso aparece uma única vez (`DP-PT-011`): depois do Concluir, não volta. */
export function CodigoDeAcesso({ codigo, aoConcluir }: { codigo: string; aoConcluir: () => void }) {
    return (
        <>
            <p className="rotulo-codigo">Código de acesso</p>
            <p className="codigo-de-acesso">{codigo}</p>
            <p className="aviso-codigo">Anote ou copie agora: o código não volta a aparecer.</p>
            <div className="botoes-confirmacao">
                <button
                    type="button"
                    className="botao-secundario"
                    onClick={() => void navigator.clipboard?.writeText(codigo).catch(() => undefined)}
                >
                    Copiar código
                </button>
                <button type="button" className="botao-confirmar" onClick={aoConcluir}>
                    Concluir
                </button>
            </div>
        </>
    );
}
